/*@flow*/
import t from 'tcomb';
import EmptyArray from './EmptyArray';

export default t.subtype(
  t.Any,
  x => {
    if (t.Array.is(x)) {
      return EmptyArray.is(x);
    } else if (t.Object.is(x)) {
      return Object.keys(x).length === 0;
    }
    return x === undefined || x === null || x === '';
  },
  'Blank'
);
